// An NPI is ten digits whose last digit is a Luhn check digit computed over the number prefixed with 80840.
export function isValidNpi(value) {
    if (!/^\d{10}$/.test(String(value || ''))) return false

    const digits = `80840${value}`.split('').reverse().map(Number)
    const sum = digits.reduce((total, digit, index) => {
        if (index % 2 === 1) {
            const doubled = digit * 2
            return total + (doubled > 9 ? doubled - 9 : doubled)
        }
        return total + digit
    }, 0)

    return sum % 10 === 0
}
